import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { DialogAnimationService } from 'src/app/angular-core/services/dialog-animation.service';
import { NewsItem } from 'src/app/generated/CrossPoint.Sales.Server';
import { IPermission } from 'src/app/shared/guards/authorized.guard';
import { getNewsAction } from 'src/app/store/actions/sales.actions';
import { selectNews } from 'src/app/store/selectors/sales.selector';
import { OperationEnum } from 'src/app/utils/enums/operation.enums';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';
import { NewsItemContentComponent } from './news-item-content/news-item-content.component';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ActivatedRoute, Router } from '@angular/router';


@UntilDestroy()
@Component({
  selector: 'xpac-articles',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsComponent implements OnInit {
  // public
  public isLoading: boolean = true;
  public news: NewsItem[] = [];

  constructor(
    private store: Store<IRemoteXPACPortalState>,
    private cdr: ChangeDetectorRef,
    private readonly router: Router,
    private dialog: DialogAnimationService,
    private readonly activatedRoute: ActivatedRoute,
    private googleAnalytics: GoogleAnalyticsService,
  ) {}

  public agGetRequiredPermissions(): IPermission[] {
    return [
      { type: 'News', operation: OperationEnum.READ }
    ];
  }

  public get newsItemId(): string {
    return this.activatedRoute.snapshot.params.newsItemId;
  }

  public onNewsItemClick(newsItem: NewsItem) {
    // bit of a hack but we want to update the url
    if (this.newsItemId == undefined) {
      this.router.navigate(['/articles/' + newsItem.id], { replaceUrl: true });
    }
    else {
      const dialogRefref = this.dialog.open(NewsItemContentComponent, {
        panelClass: 'my-full-screen-dialog',
        data: newsItem,
        animation: { to: "left" }
      });
      this.googleAnalytics.trackPageView(`News - ${newsItem.title}`, `${document.location.origin}/news/${newsItem.id}`);

      dialogRefref.afterClosed().subscribe(() => {
        if (this.newsItemId != undefined) {
          this.router.navigate(['/articles'], { replaceUrl: true });
        }
      })
    }

  }

  public ngOnInit(): void {
    this.initData();
  }

  private initData(): void {
    this.store.dispatch(getNewsAction({ data: {} }));
    this.store.select(selectNews)
      .pipe(
        filter<NewsItem[]>(Boolean),
        untilDestroyed(this)
      )
      .subscribe((news: NewsItem[]) => {
        this.news = news;
        this.isLoading = false;
        const newsId = this.newsItemId?.replace(/^(\d{4}-)/, '');
        const newsItem = this.news?.find(ni => ni.id === newsId);
        if (newsItem) {
          this.onNewsItemClick(newsItem);
        }
        this.cdr.markForCheck();
      });
  }
}
